export const getEpisodeLabel = (number: string) => {
  return `Episode ${number.replaceAll('-', ' ')}`
}